export type LottieColor = [number, number, number, number];

/** Convert a `#RRGGBB` hex string to a lottie normalized RGBA tuple (0–1). */
export function hexToLottieColor(hex: string): LottieColor {
    const normalized = hex.replace('#', '');
    const r = parseInt(normalized.slice(0, 2), 16) / 255;
    const g = parseInt(normalized.slice(2, 4), 16) / 255;
    const b = parseInt(normalized.slice(4, 6), 16) / 255;
    return [r, g, b, 1];
}

/** Recursively set every fill (`ty: 'fl'`) color in a lottie node tree. */
export function recolorFills(node: unknown, color: LottieColor): void {
    if (Array.isArray(node)) {
        node.forEach((child) => recolorFills(child, color));
        return;
    }
    if (node && typeof node === 'object') {
        const obj = node as Record<string, unknown>;
        if (obj.ty === 'fl' && obj.c && typeof obj.c === 'object') {
            (obj.c as { k: LottieColor }).k = [...color];
        }
        Object.values(obj).forEach((value) => recolorFills(value, color));
    }
}
